import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const OMMComponent = () => {
  const [fontSize, setFontSize] = useState('1rem');
  const [titleSize, setTitleSize] = useState('1.2rem');
  const [imgWidth, setImgWidth] = useState('11rem');

  useEffect(() => {
    const updateSizes = () => {
      const w = window.innerWidth;
      if (w < 400) {
        setFontSize('0.38rem');
        setTitleSize('0.65rem');
        setImgWidth('28%');
      } else if (w < 500) {
        setFontSize('0.45rem');
        setTitleSize('0.75rem');
        setImgWidth('30%');
      } else if (w < 600) {
        setFontSize('0.60rem');
        setTitleSize('0.9rem');
        setImgWidth('31%');
      } else if (w < 700) {
        setFontSize('0.68rem');
        setTitleSize('1rem');
        setImgWidth('32%');
      } else {
        setFontSize('0.85rem');
        setTitleSize('1.2rem');
        setImgWidth('11rem');
      }
    };

    updateSizes();
    window.addEventListener('resize', updateSizes);
    return () => window.removeEventListener('resize', updateSizes);
  }, []);

  const sharedBoxStyle = {
    backgroundColor: 'rgba(32, 32, 32, 0.55)',
    borderRadius: '30px',
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.2)',
    color: 'white',
    fontFamily: 'Noto Sans, sans-serif',
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        px: 2,
        py: 3,
      }}
    >
      <Box
        sx={{
          ...sharedBoxStyle,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          padding: 2,
          gap: 2,
          maxWidth: '1100px',
          width: '100%',
        }}
      >
        {/* Left: Image with 2:3 aspect ratio enforced */}
        <Box
          sx={{
            width: imgWidth,
            position: 'relative',
            flexShrink: 0,
            borderRadius: '6px',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              display: 'block',
              paddingTop: '150%',
            },
          }}
        >
          <Box
            component="img"
            src="/images/massage.jpg"
            alt="Osteopathic manipulative medicine treatment"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Box>

        {/* Right: Text */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', pr: 1 }}>
          <Typography
            component="h2"
            variant="h5"
            sx={{
              fontWeight: 'bold',
              fontSize: titleSize,
              mb: 1.5,
            }}
          >
            About OMM
          </Typography>

          <Typography
            sx={{
              fontSize: fontSize,
              lineHeight: 1.5,
              textAlign: 'left',
            }}
          >
            Osteopathic Manipulative Medicine (OMM) is a hands-on approach to diagnosing, treating, and
            preventing illness or injury. As a Doctor of Osteopathic Medicine (DO), I use my hands to gently
            manipulate the muscles, joints, and tissues of the body to help restore alignment, improve mobility,
            and support the body’s natural ability to heal itself.
            <br /><br />
            Osteopathy is a way of life. It can be beneficial for people of all ages — from newborns to older
            adults — and is often used to treat pain, improve function, and support whole-body wellness. Whether
            you're recovering from an injury, managing chronic pain, or simply feeling out of balance, OMM
            provides a non-invasive, medication-free option for relief and support.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OMMComponent;
